import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledHead = styled.div`
	position: relative;
	height: 40px;
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);

	${Text} {
		position: absolute;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		font-size: 18px;
		font-weight: 500;
		color: #ffffff;
	}
`;

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

const StyledFinesContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	height: 334px;
	padding-top: 20px;
	overflow-y: auto;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledFine = styled.div`
	display: grid;
	grid-template-columns: 1fr auto 14px;
	gap: 10px;
	align-items: center;
	height: 50px;
	min-height: 50px;
	padding: 0 15px;
	border: 1px solid rgba(255, 255, 255, 0.1);
	background-color: rgba(255, 255, 255, 0.05);
	border-radius: 10px;

	${Text} {
		font-weight: 500;
		font-size: 14px;
		color: #ffffff;
	}
`;

const StyledNoFinesText = styled(Text)`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 185px;
	text-align: center;
	font-size: 14px;
	color: #ffffff;
	opacity: 0.25;
`;

const StyledButtonContainer = styled.div`
	margin-top: 20px;
`;

const StyledButtonContent = styled.div`
	display: flex;
	gap: 10px;
	align-items: center;
`;

export {
	StyledButtonContainer,
	StyledButtonContent,
	StyledContainer,
	StyledFine,
	StyledFinesContainer,
	StyledHead,
	StyledNoFinesText,
};
